import React from "react";
import { FaInbox } from "react-icons/fa";

export default function Invite(props) {

  return (
    <>
      <div className="icon-button">
        <FaInbox/>
      </div>
    </>
  );
}
